const RESOLUTIONS = [
  { id: '1920x1080', label: '1080p landscape · 16:9', width: 1920, height: 1080 },
  { id: '1080x1920', label: '1080p portrait · 9:16', width: 1080, height: 1920 },
  { id: '1280x720', label: '720p landscape · 16:9', width: 1280, height: 720 },
  { id: '720x1280', label: '720p portrait · 9:16', width: 720, height: 1280 },
  { id: '1440x1080', label: 'Landscape · 4:3', width: 1440, height: 1080 },
  { id: '1080x1440', label: 'Portrait · 3:4', width: 1080, height: 1440 },
  { id: '1080x1080', label: 'Square · 1:1', width: 1080, height: 1080 },
];

function isResolution(width, height) {
  return RESOLUTIONS.some((item) => item.width === width && item.height === height);
}

function facingFromLabel(label) {
  const text = String(label || '').toLowerCase();
  if (/front|user|facetime|selfie/.test(text)) return 'user';
  if (/back|rear|environment|ultra|telephoto|wide/.test(text)) return 'environment';
  return '';
}

function buildVideoConstraints(settings) {
  const video = {};
  if (settings?.cameraId) {
    video.deviceId = { exact: settings.cameraId };
  } else {
    video.facingMode = { ideal: settings?.facing === 'user' ? 'user' : 'environment' };
  }
  if (settings?.width && settings?.height) {
    video.width = { ideal: settings.width };
    video.height = { ideal: settings.height };
    video.aspectRatio = { ideal: settings.width / settings.height };
  }
  return { audio: true, video };
}

module.exports = { RESOLUTIONS, isResolution, facingFromLabel, buildVideoConstraints };
